import { render, staticRenderFns } from "./MatchResultForm.vue?vue&type=template&id=0299078f&scoped=true&"
import script from "./MatchResultForm.vue?vue&type=script&lang=js&"
export * from "./MatchResultForm.vue?vue&type=script&lang=js&"
import style0 from "./MatchResultForm.vue?vue&type=style&index=0&id=0299078f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0299078f",
  null
  
)

component.options.__file = "MatchResultForm.vue"
export default component.exports